<div class="issue-banner" [class.issue-banner--orphan]="issue.kind === 'OrphanStock'">
  <div *ngIf="issue.kind === 'WrongBasket'">
    <strong>⚠ Wrong basket.</strong>
    <span *ngIf="issue.medicationName">{{ issue.medicationName }}</span>
    <span> belongs in basket #{{ issue.expectedBasket }}<span *ngIf="issue.expectedPatient"> ({{ issue.expectedPatient }})</span>.</span>
    <div class="issue-banner__actions">
      <button class="btn btn-primary" (click)="moveNow.emit()">Move to #{{ issue.expectedBasket }} now</button>
      <button class="btn btn-outline-secondary" (click)="defer.emit()">Defer to end of session</button>
    </div>
  </div>
  <div *ngIf="issue.kind === 'OrphanStock'">
    <strong>No prescription in this batch needs this barcode.</strong> ({{ issue.scannedProductId }})
    <div class="issue-banner__actions">
      <button class="btn btn-outline-primary" (click)="defer.emit()">Defer for return-to-stock</button>
      <button class="btn btn-link" (click)="dismiss.emit()">Cancel</button>
    </div>
  </div>
</div>
